import { render, staticRenderFns } from "./DecodedId.vue?vue&type=template&id=5012b99a"
import script from "./DecodedId.vue?vue&type=script&lang=js"
export * from "./DecodedId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports